import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import style from '../style.module.less';
import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';
import { FormattedMessage } from 'react-intl';

const ErrorOrWarning = ({ errorMessage = '', fulfillmentPlanId = '', openFulfillmentPlanDetailsById = noop }) => {
  const [salesOrderId] =
    useSelector((state) =>
      Global.selectEntitiesSalesOrderIdsByFulfillmentPlanIds(state, {
        fulfillmentPlanIds: [fulfillmentPlanId],
      }),
    ) || [];
  return (
    <div className={style['error-warn-wrap']}>
      <div className={style['error-warn-number']}>
        <Button
          className={style['error-warn-link']}
          onClick={() => openFulfillmentPlanDetailsById(salesOrderId, fulfillmentPlanId)}
          theme='link'
        >
          <FormattedMessage defaultMessage='Shipment #' description='errorOrWarning.orderNumber' id='/ic3Jr' />
          {fulfillmentPlanId}
        </Button>
      </div>
      <div className={style['error-warn-message']}>{errorMessage}</div>
    </div>
  );
};

ErrorOrWarning.propTypes = {
  errorMessage: PropTypes.string,
  fulfillmentPlanId: PropTypes.string,
  openFulfillmentPlanDetailsById: PropTypes.func,
};

export default ErrorOrWarning;
